export const generateId = () => Math.random().toString(36).toString(36).substr(2, 9)

export const removeHyphensAndCapitalize = (str) => {
  return str.replace(/\//g, "").replace(/-{1,}/g, ' ').replace(/(\s{1,}|\b)(\w)/g, function (m, space, letter) {
    return space + letter.toUpperCase();
  })
}

export const addEllipses = str => `${str.substr(0, 199)} ...`

export const getNoSymbsLowerCaseStr = str => str.toLowerCase().split('-').join('')

export const getAddHyphensLowerCaseStr = str => str.replace(/\s+/g, '-').toLowerCase()

export const imgUrlGenerate = (imgName, publicFolder = `/assets/img/`) => `${process.env.PUBLIC_URL}${publicFolder}${imgName}`

export const emailRegExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
